import script from "./ErrorPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorPanel.vue?vue&type=style&index=0&id=0b00f1a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b00f1a0"]])

export default __exports__